if ( !customElements.get( 'custom-collection-list-header' ) ) {
    class CustomCollectionListHeader extends HTMLElement {
        connectedCallback() {
            this.handleCarousel();
            this.handleResize();
        }

        handleCarousel() {
            this.elem = this.querySelector('.main-carousel');
            if (!this.elem) return;

            this.initFlickity();
        }

        initFlickity() {
            if ( this.flkty ) {
                this.flkty.destroy();
            }

            this.flkty = new Flickity( this.elem, {
                cellAlign: 'center',
                contain: true,
                draggable: true,
                prevNextButtons: false,
                pageDots: false,
            });
        }

        handleResize() {
            let resizeTimeout;
            let lastWidth = window.innerWidth;

            window.addEventListener('resize', () => {
                if ( window.innerWidth === lastWidth ) { 
                    return; 
                }

                lastWidth = window.innerWidth;

                clearTimeout( resizeTimeout );
                
                resizeTimeout = setTimeout( () => {
                    this.initFlickity();
                }, 200 );
            });
        }
    }

    customElements.define( 'custom-collection-list-header', CustomCollectionListHeader );
}